
import firebase from 'firebase/app';

import { useCollection } from "react-firebase-hooks/firestore";

import Styles from './Main.module.scss';

function RoomList(
	{ currentRoomId, setCurrentRoomId, roomsCollection } :
	{
		currentRoomId: string | null,
		setCurrentRoomId: ((id: string) => any),
		roomsCollection: firebase.firestore.Query,
	}
) {
	const [rooms, roomsLoading, roomsError] = useCollection(roomsCollection);

	return <>
		{
			roomsLoading ? <p>Loading</p> :
		 	roomsError ? <p>{JSON.stringify(roomsError)}</p> :
			rooms?.empty ? <p>No rooms to show</p> :
			rooms?.docs.map(roomDoc =>
			<div key={roomDoc.id}
				className={roomDoc.id === currentRoomId
					? Styles.selectedRoomEntry
					: Styles.roomEntry}
				onClick={() => setCurrentRoomId(roomDoc.id)}>
				{roomDoc.data().name}
			</div>)
		}
	</>;
}

export default RoomList;
